export const ta = {
	content: `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv=Content-Type  content="text/html; charset=utf-8" ><meta name=ProgId  content=Word.Document ><meta name=Generator  content="Microsoft Word 14" ><meta name=Originator  content="Microsoft Word 14" ><link rel=File-List  href="Finvu (CTPL)_Terms and Conditions_TA.files/filelist.xml" ><title>Finvu</title><!--[if gte mso 9]><xml><o:DocumentProperties><o:Author>Rucha Ghude</o:Author><o:LastAuthor>Mukthyar Lukmandin</o:LastAuthor><o:Revision>1</o:Revision><o:Pages>3</o:Pages><o:Characters>22807</o:Characters><o:Lines>190</o:Lines><o:Paragraphs>53</o:Paragraphs></o:DocumentProperties><o:CustomDocumentProperties><o:KSOProductBuildVer dt:dt="string" >1033-12.2.0.20795</o:KSOProductBuildVer><o:ICV dt:dt="string" >F96456EADE28400B93DB156DE9FB9030_13</o:ICV></o:CustomDocumentProperties></xml><![endif]--><!--[if gte mso 9]><xml><o:OfficeDocumentSettings></o:OfficeDocumentSettings></xml><![endif]--><!--[if gte mso 9]><xml><w:WordDocument><w:BrowserLevel>MicrosoftInternetExplorer4</w:BrowserLevel><w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery><w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery><w:DocumentKind>DocumentNotSpecified</w:DocumentKind><w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing><w:PunctuationKerning></w:PunctuationKerning><w:View>Web</w:View><w:Compatibility><w:DontGrowAutofit/><w:DoNotExpandShiftReturn/></w:Compatibility><w:Zoom>0</w:Zoom></w:WordDocument></xml><![endif]--><!--[if gte mso 9]><xml><w:LatentStyles DefLockedState="false"  DefUnhideWhenUsed="true"  DefSemiHidden="true"  DefQFormat="false"  DefPriority="99"  LatentStyleCount="260" >
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Normal" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="heading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="9"  SemiHidden="false"  QFormat="true"  Name="heading 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  Name="toc 9" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footer" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="index heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="35"  SemiHidden="false"  QFormat="true"  Name="caption" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of figures" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="envelope return" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="footnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="line number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="page number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote reference" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="endnote text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="table of authorities" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="macro" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="toa heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Bullet 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Number 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="10"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Title" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Closing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="1"  SemiHidden="false"  Name="Default Paragraph Font" ></w:LsdException>
<w:LsdException Locked="false"  Priority="0"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Body Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Continue 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Message Header" ></w:LsdException>
<w:LsdException Locked="false"  Priority="11"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Subtitle" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Salutation" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Date" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text First Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Note Heading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Body Text Indent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Block Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Hyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="FollowedHyperlink" ></w:LsdException>
<w:LsdException Locked="false"  Priority="22"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Strong" ></w:LsdException>
<w:LsdException Locked="false"  Priority="20"  SemiHidden="false"  UnhideWhenUsed="false"  QFormat="true"  Name="Emphasis" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Document Map" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Plain Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="E-mail Signature" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Normal (Web)" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Acronym" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Address" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Cite" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Code" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Definition" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Keyboard" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Preformatted" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Sample" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Typewriter" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="HTML Variable" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  QFormat="true"  Name="Normal Table" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="annotation subject" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / a / i" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="1 / 1.1 / 1.1.1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Article / Section" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Simple 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Classic 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Colorful 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Columns 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Grid 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 7" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table List 8" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table 3D effects 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Contemporary" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Elegant" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Professional" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Subtle 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Web 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Balloon Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="39"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Table Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Table Theme" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Placeholder Text" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="No Spacing" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="List Paragraph" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="99"  SemiHidden="false"  Name="Intense Quote" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 1" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 2" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 3" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 4" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 5" ></w:LsdException>
<w:LsdException Locked="false"  Priority="60"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="61"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="62"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Light Grid Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="63"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="64"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Shading 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="65"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="66"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium List 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="67"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 1 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="68"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 2 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="69"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Medium Grid 3 Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="70"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Dark List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="71"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Shading Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="72"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful List Accent 6" ></w:LsdException>
<w:LsdException Locked="false"  Priority="73"  SemiHidden="false"  UnhideWhenUsed="false"  Name="Colorful Grid Accent 6" ></w:LsdException>
</w:LatentStyles></xml><![endif]--><style>
@font-face{
font-family:"Times New Roman";
}

@font-face{
font-family:"宋体";
}

@font-face{
font-family:"Courier New";
}

@font-face{
font-family:"Wingdings";
}

@font-face{
font-family:"Arial";
}

@list l0:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l0:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l0:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level1{
mso-level-number-format:lower-roman;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l1:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l1:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l2:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l2:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l3:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l3:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l4:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l4:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l5:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l5:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l6:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l6:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level1{
mso-level-start-at:3;
mso-level-number-format:decimal;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:'Times New Roman';}

@list l7:level2{
mso-level-number-format:decimal;
mso-level-suffix:tab;
mso-level-text:"%1.%2";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l7:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l7:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l8:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l8:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level1{
mso-level-number-format:lower-roman;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l9:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l9:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l10:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l10:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l11:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l11:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level1{
mso-level-start-at:4;
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l12:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l12:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l13:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l13:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level1{
mso-level-start-at:2;
mso-level-number-format:lower-roman;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l14:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l14:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l15:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l15:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l16:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l16:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l17:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l17:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level1{
mso-level-number-format:lower-roman;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l18:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l18:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level1{
mso-level-number-format:decimal;
mso-level-suffix:tab;
mso-level-text:"%1.";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l19:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l19:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l20:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l20:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level1{
mso-level-number-format:lower-roman;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l21:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l21:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level1{
mso-level-number-format:lower-roman;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l22:level2{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l22:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level1{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"(%1)";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;font-weight:normal;font-style:normal;font-variant:normal;font-size:12.75pt;}

@list l23:level2{
mso-level-number-format:alpha-lower;
mso-level-suffix:tab;
mso-level-text:"%1.%2";
mso-level-tab-stop:none;
mso-level-number-position:left;
margin-left:0.0000pt;
text-indent:0.0000pt;
font-family:'Times New Roman';}

@list l23:level3{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level4{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level5{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level6{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level7{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level8{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

@list l23:level9{
mso-level-start-at:0;
mso-level-number-format:decimal;
mso-level-suffix:tab;
}

p.MsoNormal{
mso-style-name:Normal;
mso-style-parent:"";
margin:0pt;
margin-bottom:.0001pt;
mso-pagination:none;
font-family:'Courier New';
color:rgb(0,0,0);
font-size:12.0000pt;
}

span.10{
font-family:'Courier New';
}

span.15{
font-family:Arial;
color:rgb(22,28,45);
font-weight:normal;
font-style:normal;
font-variant:normal;
font-size:7.5000pt;
}

span.16{
font-family:'Times New Roman';
font-weight:normal;
font-style:normal;
font-variant:normal;
font-size:10.0000pt;
}

span.17{
font-family:Arial;
color:rgb(56,76,116);
font-weight:normal;
font-style:normal;
font-variant:normal;
font-size:12.75pt;
}

span.18{
font-family:Arial;
color:rgb(56,76,116);
font-weight:normal;
font-style:normal;
font-variant:normal;
font-size:12.75pt;
}

p.MsoBodyText{
mso-style-name:"Body Text";
margin-bottom:4.0000pt;
mso-pagination:none;
line-height:150%;
font-family:Arial;
color:rgb(56,76,116);
font-size:12.75pt;
}

p.20{
mso-style-name:"Heading \#1";
margin-top:29.0000pt;
margin-bottom:4.0000pt;
mso-pagination:none;
mso-outline-level:1;
font-family:Arial;
color:rgb(22,28,45);
font-size:7.5000pt;
}

p.21{
mso-style-name:"Header or footer \(2\)";
margin:0pt;
margin-bottom:.0001pt;
mso-pagination:none;
font-family:'Times New Roman';
color:rgb(0,0,0);
font-size:10.0000pt;
}

p.22{
mso-style-name:Other;
margin-bottom:4.0000pt;
mso-pagination:none;
line-height:150%;
font-family:Arial;
color:rgb(56,76,116);
font-size:12.75pt;
}

span.msoIns{
mso-style-type:export-only;
mso-style-name:"";
text-decoration:underline;
text-underline:single;
color:blue;
}

span.msoDel{
mso-style-type:export-only;
mso-style-name:"";
text-decoration:line-through;
color:red;
}

table.MsoNormalTable{
mso-style-name:"Table Normal";
mso-style-parent:"";
mso-style-noshow:yes;
mso-tstyle-rowband-size:0;
mso-tstyle-colband-size:0;
mso-padding-alt:0.0000pt 5.4000pt 0.0000pt 5.4000pt;
mso-para-margin:0pt;
mso-para-margin-bottom:.0001pt;
mso-pagination:widow-orphan;
font-family:'Times New Roman';
font-size:10.0000pt;
mso-ansi-language:#0400;
mso-fareast-language:#0400;
mso-bidi-language:#0400;
}
@page{mso-page-border-surround-header:no;
	mso-page-border-surround-footer:no;}@page Section0{
margin-top:9.1000pt;
margin-bottom:21.4000pt;
margin-left:67.7000pt;
margin-right:22.1000pt;
size:612.0000pt 792.0000pt;
layout-grid:18.0000pt;
mso-header-margin:0.0000pt;
mso-footer-margin:0.1500pt;
mso-footer:url("Finvu%20\(CTPL\)_Terms%20and%20Conditions_TA.files/header.html") f0;
}
div.Section0{page:Section0;}</style></head><body style="tab-interval:36pt;text-justify-trim:punctuation;" ><!--StartFragment--><div class="Section0"  style="layout-grid:18.0000pt;" ><p class=20  align=justify  style="page-break-after:avoid;mso-pagination:lines-together;text-align:justify;
text-justify:inter-ideograph;" ><a name="bookmark0" ></a><span class="15"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:22.5pt;" >சேவை விதிமுறைகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-size:22.5pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:24.0000pt;text-align:justify;text-justify:inter-ideograph;" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(80,102,144);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >2-</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(80,102,144);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஜனவரி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(80,102,144);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >-2025 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(80,102,144);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அன்று புதுப்பிக்கப்பட்டது</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-align:justify;text-justify:inter-ideograph;" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் மற்றும் நிபந்தனைகள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விதிமுறைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") Finvu </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பயன்பாடு மற்றும் வலைத்தளம் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மற்றும் சேவைகளுக்கான அணுகல் மற்றும் பயன்பாட்டை நிர்வகிக்கின்றன </span><i style="mso-bidi-font-style:normal" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;mso-ansi-font-style:italic;mso-bidi-font-style:normal;
font-variant:normal;font-size:12.75pt;" >{</span></i><i><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:italic;font-variant:normal;
font-size:12.75pt;" >கீழே வரையறுக்கப்பட்டுள்ளன</span></i><i style="mso-bidi-font-style:normal" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;mso-ansi-font-style:italic;mso-bidi-font-style:normal;
font-variant:normal;font-size:12.75pt;" >).</span></i><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-align:justify;text-justify:inter-ideograph;" ><span><a href="http://www.finvu.in/privacy" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >www.finvu.in/privacy</span></a></span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >-</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் கிடைக்கும் எங்கள் தனியுரிமைக் கொள்கை &nbsp;</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தனியுரிமைக் கொள்கை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மற்றும் அவ்வப்போது எங்களால் கிடைக்கப்பெறும் அல்லது வழங்கப்படும் வழிகாட்டுதல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூடுதல் விதிமுறைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கொள்கைகள் அல்லது மறுப்புகள் ஆகியவை அடங்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் இங்குள்ள விதிகளின்படி எங்களால் திருத்தப்படலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் அவ்வப்போது திருத்தப்படும் விதிமுறைகள் உங்களுக்குப் பொருந்தும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தில் இந்த விதிமுறைகளின் தற்போதைய பதிப்பை நீங்கள் எப்போதும் மதிப்பாய்வு செய்யலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-align:justify;text-justify:inter-ideograph;" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளின் எந்தவொரு பயனருக்கும் குக்கீஜார் டெக்னாலஜீஸ் பிரைவேட் லிமிடெட் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >", "</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >", "Finvu", </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களுக்கு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"), </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சூழலைப் பயன்படுத்தும் எந்தவொரு நிதித் தகவல் வழங்குநர் அல்லது நிதித் தகவல் பயனருக்கும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இடையே ஒரு பிணைப்பு மற்றும் அமல்படுத்தக்கூடிய சட்ட ஒப்பந்தத்தை உருவாக்குகின்றன</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குக்கீஜார் டெக்னாலஜீஸ் பிரைவேட் லிமிடெட் நிறுவனம் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >RBI </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உரிமம் பெற்றது மற்றும் கணக்கு ஒருங்கிணைப்பாளராக செயல்பட இந்திய ரிசர்வ் வங்கி </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(RBI) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வழங்கிய பதிவுச் சான்றிதழைக் கொண்டுள்ளது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, 1934 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆம் ஆண்டு இந்திய ரிசர்வ் வங்கிச் சட்டத்தின் பிரிவு </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >45 IA -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இன் கீழ் இந்திய ரிசர்வ் வங்கியால் வழங்கப்பட்ட </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >06 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மார்ச் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >2020 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தேதியிட்ட செல்லுபடியாகும் பதிவுச் சான்றிதழைக் கொண்டுள்ளது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. (a) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளை ஒப்புக்கொண்டு அவற்றுடன் உங்களை இணைத்துக் கொள்ள முழு சட்டத் திறனும் அதிகாரமும் உங்களிடம் உள்ளது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(b) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் ஒரு தனிநபராக இருந்தால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் பதினெட்டு வயது மற்றும் அதற்கு மேற்பட்டவர் அல்லது நீங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >18 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வயதுக்குட்பட்டவராக இருந்தால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளைப் பயன்படுத்த பெற்றோர் அல்லது சட்டப்பூர்வ பாதுகாவலரின் உதவியைப் பெற வேண்டும் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(c) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்தியாவில் குடியிருப்பவர் என்பதை நீங்கள் பிரதிநிதித்துவப்படுத்தி உத்தரவாதம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் ஒரு நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அமைப்பு அல்லது வேறு எந்த சட்டப்பூர்வ நபரையும் பிரதிநிதித்துவப்படுத்தினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அமைப்பு அல்லது சட்டப்பூர்வ நபரை இந்த விதிமுறைகளுக்கு பிணைக்க தேவையான திறனும் அதிகாரமும் உங்களிடம் உள்ளது என்பதை உறுதிப்படுத்தி பிரதிநிதித்துவப்படுத்துகிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-align:justify;text-justify:inter-ideograph;line-height:144%;" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐப் பயன்படுத்துவதன் மூலம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளைப் படித்து</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >புரிந்துகொண்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அவற்றுக்குக் கட்டுப்பட்டிருப்பதாகவும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இங்கே பட்டியலிடப்பட்டுள்ள தேவைகளுக்கு இணங்குவதாகவும் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் அனைத்தையும் நீங்கள் ஏற்கவில்லை அல்லது இங்கே பட்டியலிடப்பட்டுள்ள தேவைகளுக்கு இணங்கவில்லை என்றால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தயவுசெய்து தளத்தை அணுக வேண்டாம் அல்லது சேவைகள் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐப் பயன்படுத்த வேண்டாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.1000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >1.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வரையறைகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:157%;mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முதன்மை வழிகாட்டுதல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது முதன்மை வழிமுறை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >- </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வங்கி சாரா நிதி நிறுவனம் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >- </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கணக்கு ஒருங்கிணைப்பாளர் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ரிசர்வ் வங்கி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வழிமுறைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, 2016 -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐக் குறிக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அவ்வப்போது திருத்தப்பட்ட</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மறுபரிசீலனை செய்யப்பட்ட அல்லது புதுப்பிக்கப்பட்டவை </span><u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;" >https://www.rbi.or</span></u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >g</span><u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;" >.in/Scripts/BS_ViewMasDirections.asDx?id=</span></u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >10598 -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கிடைக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த வழிகாட்டுதல்களின் நோக்கத்திற்காக </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வாடிக்கையாளர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது எங்களால் வழங்கப்படும் சேவைகளைப் பெறுவதற்கு அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முதன்மை வழிகாட்டுதல்களின் கீழ் வரையறுக்கப்பட்டுள்ளபடி எங்களுடன் ஒப்பந்த ஏற்பாட்டில் நுழைந்த ஒரு </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >'</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நபரைக்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >' </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குறிக்கிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முதன்மை வழிகாட்டுதல்களில் கூறப்பட்டுள்ள அதே பொருளைக் கொண்டிருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதில் நிதித் தகவல் வழங்குநரிடம் கிடைக்கும் உங்கள் நிதித் தரவும் அடங்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதி தகவல் வழங்குநர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது ஒரு வங்கி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வங்கி நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வங்கி சாரா நிதி நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சொத்து மேலாண்மை நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வைப்புத்தொகை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வைப்புத்தொகை பங்கேற்பாளர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >காப்பீட்டு நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >காப்பீட்டு களஞ்சியம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஓய்வூதிய நிதி அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முதன்மை வழிகாட்டுதல்களில் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதி தகவல் வழங்குநர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்று அடையாளம் காணப்படக்கூடிய பிற நிறுவனத்தைக் குறிக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(e)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் பயனர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது எந்தவொரு நிதித் துறை ஒழுங்குமுறை ஆணையத்திடமும் பதிவுசெய்யப்பட்ட மற்றும் ஒழுங்குபடுத்தப்பட்ட ஒரு நிறுவனம் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முதன்மை வழிகாட்டுதல்களில் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் பயனர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்று அடையாளம் காணப்படக்கூடிய பிற நிறுவனத்தைக் குறிக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 10.8500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(f)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித்துறை ஒழுங்குமுறை அதிகாரி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முதன்மை வழிகாட்டுதல்களில் குறிப்பிடப்பட்டுள்ள அதே பொருளைக் கொண்டிருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(g)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தனிப்பட்ட தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தனிப்பட்ட தரவு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது அத்தகைய தரவுகளால் அல்லது தொடர்புடையதாக அடையாளம் காணக்கூடிய ஒரு நபரைப் பற்றிய எந்தவொரு தரவையும் குறிக்கிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(h)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"RBI" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது இந்திய ரிசர்வ் வங்கியைக் குறிக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 10.6000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l6 level1 lfo2;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(i)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"Sandbox" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது நிதித் தகவல் வழங்குநர் மற்றும் நிதித் தகவல் பயனர் எங்கள் சலுகைகளை மதிப்பிட அனுமதிக்கும் தளத்தில் கிடைக்கும் சோதனை சூழலைக் குறிக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-align:justify;text-justify:inter-ideograph;" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விதிமுறைகளுக்குள் பெரிய எழுத்துக்களில் எழுதப்பட்ட ஆனால் இந்தப் பிரிவு </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >1 -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் வரையறுக்கப்படாத சொற்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குறிப்பிட்ட பிரிவில் அவற்றுக்குக் கூறப்பட்ட பொருளைக் கொண்டிருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >2.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பணி வரம்புகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கணக்கு ஒருங்கிணைப்பு சேவைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >": </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தின் மூலம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >:</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 10.6000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l9 level1 lfo4;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(i)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் வழங்குநர்களிடம் கிடைக்கும் நிதித் தகவல்களை மீட்டெடுக்க</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பார்க்க</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒருங்கிணைக்க</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒழுங்கமைக்க மற்றும் பகிர முடியும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >; </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மற்றும்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l9 level1 lfo4;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் நிதித் தகவலை நிதித் தகவல் பயனர்களுக்கு வழங்க முடியும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தின் மூலம் எங்களால் வழங்கப்படும் கணக்கு ஒருங்கிணைப்பு சேவைகள் மற்றும் வாடிக்கையாளருக்கு தளத்தை அணுகுவதற்கான வசதி ஆகியவை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்று குறிப்பிடப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள் உங்களுக்கு சேவைகளை வழங்குவதற்காக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் பிரிவு </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >6 -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இன் படி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் வழங்குநர்களிடமிருந்து உங்கள் நிதித் தகவலை அணுக உங்கள் ஒப்புதலுடன்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வரையறுக்கப்பட்ட அதிகாரத்துடன் எங்களை உங்கள் முகவராக அங்கீகரித்து நியமிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் உங்கள் தேவைக்கேற்ப நிதித் தகவல் பயனர்களுடன் பகிர்ந்து கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l16 level1 lfo3;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருந்தக்கூடிய சட்டங்களின்படி சேவைகளுக்கு உங்களிடம் கட்டணம் வசூலிக்கும் உரிமையை நாங்கள் கொண்டுள்ளோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளுக்கு நாங்கள் கட்டணம் வசூலிக்க விரும்பினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கட்டணங்கள் எங்கள் தளத்தில் கிடைக்கும் எங்கள் விலை நிர்ணயக் கொள்கைக்கு ஏற்ப இருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூடுதலாக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எதிர்காலத்தில் ஏதேனும் கட்டணங்கள் விதிக்கப்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய சூழ்நிலைகளில் அது குறித்து உங்களுக்கு எழுத்துப்பூர்வ முன் அறிவிப்பு வழங்கப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >3.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சுயவிவர உருவாக்கம்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l23 level1 lfo5;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளைப் பெற</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் தளத்தில் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சுயவிவரம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒரு சுயவிவரத்தை உருவாக்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சுயவிவரத்தை உருவாக்க பயனர்பெயர் மற்றும் கடவுச்சொல்லை அமைப்பதோடு மட்டுமல்லாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருந்தக்கூடிய சட்டங்களால் தேவைப்படக்கூடிய பெயர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மின்னஞ்சல் முகவரி மற்றும் தொலைபேசி எண்கள் உட்பட ஆனால் அவை மட்டுமேயல்லாமல் சில விவரங்களையும் நீங்கள் வழங்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் சுயவிவரம் தொடர்பாக வழங்கப்பட்ட அனைத்து தகவல்களும் துல்லியமாகவும் உண்மையாகவும் இருக்கும் என்று நீங்கள் உத்தரவாதம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் இந்தத் தகவலில் ஏதேனும் மாற்றம் அல்லது திருத்தம் ஏற்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தில் உங்கள் விவரங்களை உடனடியாகப் புதுப்பிப்பீர்கள் என்பதை ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:145%;mso-list:l23 level1 lfo5;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஹேண்டில்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பயனர்பெயர் மற்றும் கடவுச்சொல்லின் பாதுகாப்பு மற்றும் ரகசியத்தன்மையைப் பராமரிப்பதற்கு நீங்கள் மட்டுமே பொறுப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் உங்கள் சுயவிவரத்தின் எந்தவொரு வெளிப்படுத்தல் அல்லது அங்கீகரிக்கப்படாத பயன்பாடு அல்லது உங்கள் சுயவிவரத்தைப் பொறுத்தவரை வேறு ஏதேனும் பாதுகாப்பு மீறல் ஏற்பட்டால் அது குறித்து உடனடியாக எங்களுக்குத் தெரிவிக்க ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(i) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உடனடியாக எங்களிடம் புகாரளிப்பீர்கள் மற்றும் உங்களுக்குத் தெரிந்த அல்லது சந்தேகிக்கப்படும் சேவைகளின் எந்தவொரு அங்கீகரிக்கப்படாத பயன்பாட்டையும் நிறுத்த நியாயமான முயற்சிகளை மேற்கொள்வீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(ii) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளை அணுக அல்லது பயன்படுத்த தவறான அடையாளத் தகவலை வழங்கமாட்டீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. "AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஹேண்டில்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >என்பது எங்கள் தளத்தில் உங்கள் பதிவின் போது உருவாக்கப்பட்ட ஒரு தனித்துவமான அடையாளங்காட்டியைக் குறிக்கிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இது தளத்தை அணுகவும் சேவைகளை வழங்கவும் தரப்பினரால் பயன்படுத்தப்படுகிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l23 level1 lfo5;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் சுயவிவரத்தின் மூலம் நடைபெறும் அனைத்து நடவடிக்கைகளுக்கும் நீங்கள் பொறுப்பேற்க வெளிப்படையாக ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் சுயவிவரத்திற்கான எந்தவொரு அங்கீகரிக்கப்படாத அணுகலுக்கும் நாங்கள் எந்த வகையிலும் பொறுப்பேற்க மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் முறையற்ற பயன்பாட்டினால் நேரடியாகவோ அல்லது மறைமுகமாகவோ ஏற்படும் தரவு அல்லது செயல்பாட்டு இழப்புக்கு நாங்கள் பொறுப்பேற்க மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;text-indent:7.0000pt;tab-stops:left blank 21.1500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l7 level2 lfo6;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >3.1<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >KYC</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:157%;mso-list:l5 level1 lfo7;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளின் சில அம்சங்களைப் பெற விரும்பும் தளத்தின் பயனர்கள் தொடர்பாக சில </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் வாடிக்கையாளரை அறிந்து கொள்ளுங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >செயல்முறைகளை நாங்கள் மேற்கொள்ள வேண்டியிருக்கலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இது சம்பந்தமாக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அவ்வப்போது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, &#8203;&#8203;</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளின் சில அம்சங்களைப் பயன்படுத்துவதற்கான உங்கள் தகுதியை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("KYC </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆவணங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உறுதிப்படுத்தத் தேவையான தகவல்களையும் ஆவணங்களையும் பதிவேற்றுமாறு நாங்கள் உங்களிடம் கேட்டுக்கொள்வோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l5 level1 lfo7;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >KYC </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆவணங்களைச் செயல்படுத்தவும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் தகுதியை உறுதிப்படுத்தவும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களுக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள் ஈடுபடக்கூடிய எந்தவொரு மூன்றாம் தரப்பு சேவை வழங்குநருக்கும் நீங்கள் அங்கீகாரம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களால் மேற்கொள்ளப்படும் எந்தவொரு செயலாக்கமும் எங்கள் தனியுரிமைக் கொள்கையின்படி இருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்தப் பிரிவின் கீழ் மூன்றாம் தரப்பு தகவல்களைச் செயலாக்கினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூடுதல் சேவை விதிமுறைகளுக்கு நீங்கள் உட்பட்டிருக்கலாம் என்பதை ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தகுதியை தீர்மானிக்க ஏதேனும் கூடுதல் தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தரவு அல்லது ஆவணப்படுத்தல் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூட்டாக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, "</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூடுதல் தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >") </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தேவைப்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கோரிக்கையின் பேரில் அத்தகைய கூடுதல் தகவல்களை உடனடியாகப் பகிர்ந்து கொள்ள நீங்கள் இதன்மூலம் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய கூடுதல் தகவல்களைச் செயல்படுத்த எங்களுக்கு அங்கீகாரம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l5 level1 lfo7;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உண்மையான</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முழுமையான மற்றும் புதுப்பித்த </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >KYC </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆவணங்கள் மற்றும் கூடுதல் தகவல்களை வழங்க நீங்கள் ஒப்புக்கொள்கிறீர்கள் மற்றும் உத்தரவாதம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, (i) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இது தொடர்பாக வழங்கப்படும் எந்தவொரு தவறான அல்லது தவறாக வழிநடத்தும் தகவலும் இந்த விதிமுறைகளின் குறிப்பிடத்தக்க மீறலாகும் என்பதையும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, (ii) KYC </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆவணங்கள் மற்றும் கூடுதல் தகவல்களைப் பகிரத் தவறினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளின் சில அம்சங்களுக்கான உங்கள் அணுகல் மட்டுப்படுத்தப்படலாம் அல்லது மறுக்கப்படலாம் என்பதையும் நீங்கள் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;text-indent:7.0000pt;tab-stops:left blank 21.1500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l7 level2 lfo6;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >3.2<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தரவைப் பயன்படுத்துவதற்கான ஒப்புதல்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் நிதித் தகவல்களை நாங்கள் சேமிக்கவோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அணுகவோ அல்லது பார்க்கவோ மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. ReBIT (</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ரிசர்வ் வங்கி தகவல் தொழில்நுட்ப தனியார் லிமிடெட்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வரையறுக்கப்பட்ட </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >NBFC-AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தொழில்நுட்ப விவரக்குறிப்புகளின்படி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சுயவிவரத்தை உருவாக்கவும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் நிதிக் கணக்குகளைக் கண்டறிய உதவவும் உங்கள் மொபைல் எண்ணை நாங்கள் சேகரித்து சரிபார்க்கிறோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் ஒப்புதல் தொடர்பான செயல்கள் பற்றிய </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >SMS </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அறிவிப்புகளை அனுப்ப</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் மொபைல் எண் மறைகுறியாக்கப்பட்ட வடிவத்தில் பாதுகாப்பாக சேமிக்கப்படுகிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூடுதலாக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஏதேனும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >FIP </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தேவைப்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >PAN </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மற்றும் பிறந்த தேதி </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Finvu AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அமைப்பின் மூலம் மறைக்கப்பட்ட வடிவத்தில் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(ReBIT </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மூலம் வெளியிடப்பட்ட </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >NBFC-AA </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தொழில்நுட்ப விவரக்குறிப்புகளின்படி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அனுப்பப்பட்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இணைக்கப்பட்ட துல்லியமான கணக்குகளை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >FIP </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கண்டறிய உதவும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. PAN </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மற்றும் பிறந்த தேதி ஆகியவை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Finvu AA -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் சேமிக்கப்படுவதில்லை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 19.0500pt ;text-align:justify;
text-justify:inter-ideograph;line-height:144%;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் சேவைகளை வழங்குவது உங்கள் நிதித் தகவல்களை வெளியிடுவதற்கும் மாற்றுவதற்கும் உங்கள் ஒப்புதலை வழங்க உதவுகிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்புதல் சேகரிக்கப்பட்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்புதல் கலைப்பொருளைப் பயன்படுத்தி உறுதிப்படுத்தப்படுகிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதற்காக நீங்கள் பின்வரும் தரவுத்தொகுப்புகளை உறுதிப்படுத்த வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >:</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 22.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(i)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் அடையாளம் மற்றும் விருப்ப தொடர்புத் தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 23.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கோரப்படும் நிதித் தகவலின் தன்மை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய தகவல்களைச் சேகரிப்பதன் நோக்கம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 212.75pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iv)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தகவலைப் பெறுபவர்களின் அடையாளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 23.3000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(v)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்புதல் கலைப்பொருள் தகவலை அணுக ஒவ்வொரு முறையும் பயன்படுத்தப்படும்போது அறிவிப்பை அனுப்ப வேண்டிய </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >URL </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது பிற முகவரி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(vi)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்புதல் உருவாக்கும் தேதி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்புதல் காலாவதியாகும் தேதி மற்றும் உங்கள் கையொப்பம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >/</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >டிஜிட்டல் கையொப்பம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:12.0000pt;tab-stops:left blank 24.7500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l18 level1 lfo9;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(vii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருந்தக்கூடிய சட்டத்தின் கீழ் தேவைப்படக்கூடிய வேறு ஏதேனும் தகவல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களுடன் தொடர்புடைய எந்தவொரு நிதித் தகவலையும் பெற</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்புதல் கலைப்பொருள் மூலம் எங்களுக்கு வழங்கப்பட்ட உங்கள் ஒப்புதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அனைத்தையும் அல்லது எதையும் நீங்கள் எந்த நேரத்திலும் ரத்து செய்யலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ரத்து செய்யப்பட்டவுடன்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் வழங்குநரும் நிதித் தகவல் பயனரும் அத்தகைய அறிவிப்பை வழங்குவார்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:7.0000pt;tab-stops:left blank 18.8000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் மற்றும் தளத்தில் தகவல் பகிரப்பட்ட நிதித் தகவல் பயனர்கள் வழங்கிய ஒப்புதல்களின் பதிவை நீங்கள் எந்த நேரத்திலும் அணுகலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="text-indent:7.0000pt;tab-stops:left blank 18.5500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(e)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் தனியுரிமைக் கொள்கையின்படி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் தனிப்பட்ட தகவல் மற்றும் தொழில்நுட்பத் தரவு மற்றும் தொடர்புடைய தகவல்களை நாங்கள் சேகரித்துப் பயன்படுத்தலாம் என்பதை நீங்கள் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-left:7.0000pt;tab-stops:left blank 17.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(f)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தின் செயல்திறன் மற்றும் பயன்திறனை மேலும் மேம்படுத்த</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பகுப்பாய்வு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >போக்குகளின் அடையாளம் மற்றும் புள்ளிவிவரங்களுக்காக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் மற்றும் தளத்தில் உள்ள சேவைகள் மற்றும் செயல்பாடுகளின் உங்கள் பயன்பாடு தொடர்பான தரவுகளைத் தவிர்த்து மற்ற தகவல்களை நாங்கள் பயன்படுத்தலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:0.0000pt;margin-left:7.0000pt;tab-stops:left blank 18.5500pt ;
text-align:justify;text-justify:inter-ideograph;mso-list:l20 level1 lfo8;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(g)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருந்தக்கூடிய சட்டங்களுக்கு உட்பட்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குற்றவியல் நடவடிக்கைகள் அல்லது வேறு ஏதேனும் நடவடிக்கைகள் தொடர்பாக உங்களைப் பற்றிய தரவை வெளியிட சட்ட அமலாக்க முகவர் நிறுவனங்கள் அல்லது அரசாங்கம் மற்றும் தொடர்புடைய ஒழுங்குமுறை அமைப்புகளால் நாங்கள் இயக்கப்படலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதுபோன்ற சந்தர்ப்பங்களில்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய தரவை தொடர்புடைய முகமைகள் அல்லது அமைப்புகளுடன் பகிர்ந்து கொள்ள எங்களுக்கு உரிமை உண்டு என்பதை நீங்கள் புரிந்துகொண்டு ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >4.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அறிவிப்புகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l17 level1 lfo10;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிறுவனம் உங்கள் பதிவுசெய்யப்பட்ட மின்னஞ்சல் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >id </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது தொலைபேசி எண்ணுக்கு அவ்வப்போது அறிவிப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தகவல்கள் அல்லது விழிப்பூட்டல்களை அனுப்பக்கூடும் என்பதையும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளை வழங்குவதற்குத் தேவையான அத்தியாவசிய தகவல்களை நீங்கள் விலக்கிக் கொள்ள முடியாமல் போகலாம் என்பதையும் நீங்கள் புரிந்துகொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l17 level1 lfo10;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் விழிப்பூட்டல்கள் அல்லது தகவல்களைப் பெறுவதை முடக்கியிருந்தால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளை உகந்த முறையில் பயன்படுத்துவதற்காக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அதை நீங்கள் திருத்தி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விழிப்பூட்டல்களைப் பெறுவதற்கான சரியான விவரங்களை வழங்க வேண்டுமென நிறுவனம் பரிந்துரைக்கிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l17 level1 lfo10;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிறுவனத்திடமிருந்து வரும் தகவல்கள் கண்டிப்பாக சேவைகளுடன் தொடர்புடையதாக இருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >5.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் கடமைகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் வெளிப்படையான ஒப்புதலின் அடிப்படையில் நாங்கள் உங்களுக்கு சேவைகளை வழங்குவோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களுக்கு சேவைகளை வழங்குவது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களுக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களுக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் பயனர்களுக்கும் இடையே பொருத்தமான ஒப்பந்தங்கள் மற்றும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >/</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது அங்கீகாரங்களால் ஆதரிக்கப்படுவதை நாங்கள் உறுதி செய்வோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களுடன் தொடர்புடைய எந்தவொரு நிதித் தகவலையும் நாங்கள் சேமித்து வைப்பதில்லை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் சேவைகள் தொடர்பாக அவற்றை நாங்கள் செயலாக்கம் செய்யலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கணக்கு ஒருங்கிணைக்கும் தொழிலை மேற்கொள்வதற்கு மூன்றாம் தரப்பு சேவை வழங்குநரின் சேவைகளை நாங்கள் பயன்படுத்த மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l15 level1 lfo11;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(e)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பல்வேறு நிதித் தகவல் வழங்குநர்களுடனான கணக்குகள் தொடர்பான உங்கள் பயனர் அங்கீகாரச் சான்றுகளை நாங்கள் அணுக மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >6.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் பொறுப்புகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l0 level1 lfo12;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளை ஒப்புக்கொண்ட தேதியில் சேவைகள் மூலம் அல்லது சேவைகள் தொடர்பாக வழங்கப்படும் அனைத்து தகவல்களும் முழுமையானவை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உண்மையானவை மற்றும் சரியானவை என்றும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் சேவைகளைப் பெறும் வரை முழுமையானவை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உண்மையானவை மற்றும் சரியானவை என்றும் நீங்கள் பிரதிநிதித்துவப்படுத்தி உத்தரவாதம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் நடைமுறையில் இருக்கும்போது நீங்கள் வழங்கும் எந்தவொரு தகவலிலும் மாற்றம் ஏற்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உடனடியாக அந்த மாற்றத்தை எங்கள் கவனத்திற்குக் கொண்டு வந்து உங்கள் சுயவிவரத்தின் மூலம் உடனடியாகப் புதுப்பிக்க நீங்கள் உறுதியளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம் மூலம் உங்களால் அனுப்பப்படும் தகவலின் உள்ளடக்கத்தின் மீது எங்களுக்கு எந்தக் கட்டுப்பாடும் இல்லை என்பதை நீங்கள் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளைப் பெறுவதற்காக வழங்கப்பட்ட எந்தவொரு தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆவணங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருள் அல்லது தரவு தவறானதாகவோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முழுமையற்றதாகவோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >துல்லியமற்றதாகவோ அல்லது தவறாக வழிநடத்துவதாகவோ இருந்தால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது நீங்கள் ஏதேனும் முக்கியமான உண்மையை வெளியிடத் தவறினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களுக்கு ஏற்படக்கூடிய எந்தவொரு இழப்பு அல்லது சேதத்திற்கும் நாங்கள் எந்தப் பொறுப்பையும் ஏற்க மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l0 level1 lfo12;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருந்தக்கூடிய சட்டங்களுக்கு இணங்குவதை உறுதி செய்வதற்கு நீங்கள் மட்டுமே பொறுப்பாவீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் இது தொடர்பாக உங்கள் கடமைகளை மீறுவதால் ஏற்படக்கூடிய எந்தவொரு பொறுப்புக்கும் நீங்கள் மட்டுமே பொறுப்பாவீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l0 level1 lfo12;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் கீழ் உங்கள் கடமைகள் அல்லது உடன்படிக்கைகளை மீறுவதால் எங்களுக்கு எதிராக தொடங்கப்படக்கூடிய எந்தவொரு நடவடிக்கையையும் பாதுகாப்பதில் நீங்கள் எங்களுக்கு அனைத்து ஒத்துழைப்பையும் வழங்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.8500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >7.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தடைசெய்யப்பட்ட செயல்பாடுகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l13 level1 lfo13;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளில் வெளிப்படையாக அனுமதிக்கப்பட்டதைத் தவிர</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் வேறு எந்த வகையிலும் சேவைகளைப் பயன்படுத்தக்கூடாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முந்தைய வாக்கியத்தின் பொதுவான தன்மையைக் கட்டுப்படுத்தாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >:</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 10.6000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(i)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தில் நகலெடுத்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >திருத்தியமைத்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தழுவி அமைத்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மொழிபெயர்த்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ரிவர்ஸ் என்ஜினியர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தொகுப்புகளை நீக்குதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பிரித்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மாற்றியமைத்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மீண்டும் உருவாக்குதல் அல்லது வேறுவிதமாக ஏதேனும் மாற்றங்களைச் செய்தல் அல்லது ஏதேனும் வழித்தோன்றல் படைப்புகளை உருவாக்குதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >,</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மூன்றாம் தரப்பினருக்கு நேரப் பகிர்வு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தரப்படுத்தல் அல்லது பிற கணினி சேவைகளை வழங்க எந்தவிதத்திலும் தளத்தைப் பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இங்கு வெளிப்படையாக வழங்கப்பட்டுள்ளதைத் தவிர</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு மூன்றாம் தரப்பினரும் தளத்தின் செயல்பாட்டை அணுக அல்லது பயனடைய அனுமதித்தல் அல்லது எந்தவொரு போட்டி அல்லது ஒத்த தயாரிப்பையும் உருவாக்க தளத்தைப் பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 13.0000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வைரஸ்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ட்ரோஜன் ஹார்ஸ்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வார்ம்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >டைம்பாம்ப்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கீஸ்ட்ரோக் லாக்கர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஸ்பைவேர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆட்வேர் அல்லது வேறு ஏதேனும் தீங்கு விளைவிக்கும் நிரல்கள் அல்லது எந்தவொரு கணினி மென்பொருள் அல்லது வன்பொருளின் செயல்பாட்டை மோசமாக பாதிக்கும் அல்லது எந்தவொரு கணினி வளத்தின் செயல்பாட்டையும் அழிக்க அல்லது கட்டுப்படுத்த வடிவமைக்கப்பட்ட எந்தவொரு தரவையும் அனுப்ப அல்லது பதிவேற்ற சேவைகளைப் பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >,</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.5000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iv)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தை அல்லது அதன் ஏதேனும் பகுதியை கண்காணிக்க அல்லது நகலெடுக்க ஏதேனும் ரோபோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஸ்பைடர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பிற தானியங்கி சாதனம் அல்லது கைமுறை செயல்முறையைப் பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(v)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு காப்புரிமை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வர்த்தக முத்திரை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பதிப்புரிமை அல்லது பிற தனியுரிமை உரிமைகளையும் மீறுதல்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 13.0000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(vi)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தனிநபர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அதிகாரிகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இயக்குநர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஊழியர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முகவர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அங்கீகரிக்கப்பட்ட பிரதிநிதிகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மன்றத் தலைவர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வழிகாட்டிகள் அல்லது ஹோஸ்ட்கள் உட்பட</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆனால் அவர்கள் மட்டும் அல்லாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு நபரை அல்லது நிறுவனத்தை ஆள்மாறாட்டம் செய்தல் அல்லது தவறாகப் பிரதிநிதித்துவப்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது ஏதேனும் தகவலை அல்லது கணக்குகளை தவறாகக் கூறுதல் அல்லது வேறுவிதமாகத் தவறாகப் பிரதிநிதித்துவப்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 13.9500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(vii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >செய்தியின் தோற்றம் குறித்து முகவரிதாரரை ஏமாற்றுதல் அல்லது தவறாக வழிநடத்துதல் அல்லது வெளிப்படையாகத் தவறான மற்றும் உண்மையற்ற அல்லது தவறாக வழிநடத்தும் எந்தவொரு தவறான தகவல் அல்லது தகவலையும் தெரிந்தே மற்றும் வேண்டுமென்றே தொடர்புகொள்வது அல்லது மத்திய அரசின் எந்தவொரு வணிகத்தைப் பொறுத்தவரை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அமைச்சகம் அதிகாரப்பூர்வ அரசிதழில் வெளியிடப்பட்ட அறிவிப்பின் மூலம் குறிப்பிடக்கூடிய மத்திய அரசின் உண்மைச் சரிபார்ப்புப் பிரிவால் போலியானது அல்லது பொய்யானது அல்லது தவறாக வழிநடத்துவதாக அடையாளம் காணப்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 15.1500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(viii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்தியாவின் ஒற்றுமை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒருமைப்பாடு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தற்காப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பாதுகாப்பு அல்லது இறையாண்மை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வெளிநாடுகளுடனான நட்புறவு அல்லது பொது ஒழுங்கை அச்சுறுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது எந்தவொரு அறியத்தக்க குற்றத்தையும் செய்ய தூண்டுதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது எந்தவொரு குற்றத்தின் விசாரணையையும் தடுப்பது அல்லது பிற நாட்டை அவமதிப்பது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.7500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ix)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வேறொரு நபரைப் போல ஆள்மாறாட்டம் செய்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >,</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(x)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மென்பொருள் வைரஸ் அல்லது குறுக்கிட வடிவமைக்கப்பட்ட வேறு ஏதேனும் கணினி குறியீடு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கோப்பு அல்லது நிரலைக் கொண்டிருத்தல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >,</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.7500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(xi)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒரு சேகரிப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தொகுப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தரவுத்தளம் அல்லது கோப்பகத்தை நேரடியாக அல்லது மறைமுகமாக உருவாக்க அல்லது தொகுக்க தளத்திலிருந்து உள்ளடக்கத்தை முறையாக மீட்டெடுப்பதில் ஈடுபடுதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 13.9500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(xii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(A) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு சட்டவிரோத முறையிலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, (B) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மோசடி அல்லது தீங்கிழைக்கும் செயல்களுக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(C) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளுக்கு முரணான எந்த வகையிலும் சேவைகளை பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >; </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 15.1500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l1 level1 lfo14;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(xiii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருந்தக்கூடிய சட்டங்களை எந்த வகையிலும் மீறுதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l12 level1 lfo15;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்திற்கான அணுகலை குறுக்கிடும் அல்லது சீர்குலைக்கும் எந்தவொரு செயலிலும் ஈடுபடமாட்டேன் என்று நீங்கள் உத்தரவாதம் அளிக்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l12 level1 lfo15;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(e)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தின் எந்தவொரு பகுதி அல்லது அம்சத்திற்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்துடன் இணைக்கப்பட்ட வேறு எந்த அமைப்புகள் அல்லது நெட்வொர்க்குகளுக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் சேவையகங்களுக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது தளம் வழியாக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஹேக்கிங்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கடவுச்சொல் மைனிங் அல்லது வேறு எந்த சட்டவிரோத வழிகளிலும் அங்கீகரிக்கப்படாத அணுகலைப் பெற முயற்சிக்கக்கூடாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >8.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அறிவுசார் சொத்து உரிமைகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l11 level1 lfo16;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் உள்ள அனைத்து உரிமைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தலைப்பு மற்றும் ஆர்வம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் மற்றும் சாண்ட்பாக்ஸிலிருந்து எழும் அனைத்து அறிவுசார் சொத்துரிமைகள் உட்பட</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களுக்குச் சொந்தமானவை அல்லது எங்களுக்கு உரிமம் பெற்றவை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளுக்கு இணங்க</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் மற்றும் அவ்வப்போது வழங்கப்படும் அதன் எழுத்துப்பூர்வ அறிவுறுத்தல்களின்படி தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐப் பயன்படுத்த பிரத்தியேகமற்ற</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மாற்ற முடியாத</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >துணை உரிமம் பெற முடியாத</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ராயல்டி இல்லாத</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >திரும்பப்பெறக்கூடிய மற்றும் வரையறுக்கப்பட்ட உரிமத்தை நாங்கள் உங்களுக்கு வழங்குகிறோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:144%;mso-list:l11 level1 lfo16;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம் அல்லது சேவைகள் தொடர்பான பரிந்துரைகள் மற்றும் பிழை அறிக்கைகள் உட்பட பிற கருத்துக்களை அவ்வப்போது சமர்ப்பிக்குமாறு நாங்கள் உங்களிடம் கோரலாம் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கருத்து</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"). </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய கருத்துக்கான அனைத்து உரிமை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தலைப்பு மற்றும் ஆர்வத்தையும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய கருத்துகளின் அடிப்படையில் எந்தவொரு மேம்பாடுகளையும் உருவாக்குவதற்கான பிரத்யேக உரிமையையும் இதன் மூலம் எங்களுக்கு வழங்குகிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள் கருத்துக்களை சுதந்திரமாகப் பயன்படுத்தலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நகலெடுக்கலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வெளிப்படுத்தலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வெளியிடலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >காட்சிப்படுத்தலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விநியோகிக்கலாம் மற்றும் எங்கள் ஆதாயத்திற்காகப் பயன்படுத்தலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l11 level1 lfo16;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளில் கூறப்பட்டுள்ளதைத் தவிர</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளில் உள்ள எதுவும் எங்கள் அல்லது மூன்றாம் தரப்பினரின் அறிவுசார் சொத்துரிமைகளில் எந்தவொரு உரிமையையும் அல்லது உரிமத்தையும் வழங்குவதாகக் கருதப்படக்கூடாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.6000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >9.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விதிமுறைகள் மற்றும் முடித்துவைத்தல்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l10 level1 lfo17;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இங்குள்ள விதிமுறைகளின்படி முடித்துவைக்கப்படாவிட்டால் இந்த விதிமுறைகள் நடைமுறையில் இருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l10 level1 lfo17;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் கீழ் உள்ள எந்தவொரு கடமைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொறுப்புகள் அல்லது உடன்படிக்கைகளையும் நீங்கள் மீறினால் அல்லது எங்கள் சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இன் பயனர் கணக்கை ரத்து செய்யும்போது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது அதன் எந்தப் பகுதியையும் நீங்கள் அணுகுவதை அல்லது பயன்படுத்துவதை உடனடியாகவும் எந்த நேரத்திலும் எங்கள் சொந்த விருப்பப்படி நாங்கள் நிறுத்தலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l10 level1 lfo17;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் முடிவுக்கு வந்ததும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >:</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 10.6000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l21 level1 lfo18;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(i)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சுயவிவரம் காலாவதியாகிவிடும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >;</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l21 level1 lfo18;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >காலக்கெடுவை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அடையும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >; </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மற்றும்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.7500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l21 level1 lfo18;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் முடித்துவைக்கப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வெளிப்படையாக அல்லது முடித்து வைத்தப் பிறகும் நீடித்து நிலைத்திருக்க நோக்கம் கொண்ட உட்பிரிவுகளைத் தவிர</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >10.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மறுப்புகள் மற்றும் உத்தரவாதங்கள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் அல்லது அதன் மூலம் கிடைக்கப்பெறும் எந்தவொரு நிதித் தகவலின் துல்லியம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருத்தம் அல்லது சரியான தன்மைக்கு நாங்கள் உத்தரவாதம் அளிக்கவில்லை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.0500pt ;text-align:justify;text-justify:inter-ideograph;
line-height:147%;mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வெளிப்படையான</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மறைமுகமான</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சட்டரீதியான அல்லது வேறு எந்த உத்தரவாதமும் இல்லாமல் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >"</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உள்ளபடியே</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >" </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களால் வழங்கப்படுகிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதில் தலைப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, MOM-</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மீறல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வணிகத்தன்மை அல்லது ஒரு குறிப்பிட்ட நோக்கத்திற்கான தகுதிக்கான மறைமுகமான உத்தரவாதங்கள் அடங்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்கள் விண்ணப்பங்களுடன் அல்லது நீங்கள் வழங்கும் வேறு எந்த வன்பொருள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மென்பொருள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அமைப்புகள் அல்லது தரவுகளுடன் இணைந்து செயல்படும் என்று நாங்கள் உத்தரவாதம் அளிக்கவில்லை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இணையம் உட்பட தகவல் தொடர்பு வசதிகள் வழியாக தரவு பரிமாற்றத்தை நாங்கள் கட்டுப்படுத்த மாட்டோம் என்பதையும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அத்தகைய தகவல் தொடர்பு வசதிகளின் பயன்பாட்டிற்கு உட்பட்ட வரம்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தாமதங்கள் மற்றும் பிற சிக்கல்களுக்கு உட்பட்டிருக்கலாம் என்பதையும் நீங்கள் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேற்கூறியவற்றை மீறாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள் பின்வரும் உத்தரவாதங்களை அளிக்கவில்லை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >:</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 10.3500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l22 level1 lfo20;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(i)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் உள்ள செயல்பாடுகள் உங்கள் தேவைகள் அல்லது எதிர்பார்ப்புகளைப் பூர்த்தி செய்யும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது சேவைகள் அல்லது சாண்ட்பாக்ஸைப் பயன்படுத்துவது தடையின்றி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சரியான நேரத்தில்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பாதுகாப்பாக அல்லது பிழையில்லாமல் இருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >; </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l22 level1 lfo20;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தில் ஏதேனும் பிழைகள் அல்லது குறைபாடுகள் இருந்தால் அவை சரி செய்யப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களிடமிருந்து நீங்கள் வாய்மொழியாக அல்லது எழுத்துப்பூர்வமாக பெறும் ஏதேனும் ஆலோசனை அல்லது தகவல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விதிமுறைகளில் வெளிப்படையாகக் கூறப்படாத எந்தவொரு உத்தரவாதத்தையும் உருவாக்காது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் மற்றும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பயன்படுத்துவதால் ஏற்படக்கூடிய எந்தவொரு விளைவுகளுக்கும் நீங்கள் இதன்மூலம் முழுப் பொறுப்பையும் ஏற்றுக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் இது தொடர்பாக நாங்கள் எந்தப் பொறுப்பையும் கொண்டிருக்க மாட்டோம் என்பதை வெளிப்படையாக உடன்படுகிறீர்கள் மற்றும் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.8000pt ;line-height:144%;mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(e)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிதித் தகவல் வழங்குநரிடமிருந்து கோரப்படும் சில நிதித் தகவல்கள் செயலாக்கத்தில் இருக்கலாம் அல்லது நிகழ்நேரத் தகவல்களைக் கொண்டிருக்காமல் இருக்கலாம் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >டிமேட் ஃபோலியோக்கள் போன்றவை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எனவே அவை சரியான முறையில் பிரதிபலிக்காமல் போகலாம் என்பதை இதன் மூலம் நீங்கள் புரிந்துகொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதை எங்கள் சேவைகளில் உள்ள குறைபாடாகக் கருதக்கூடாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அதன்படி நாங்கள் வழங்கும் தகவல்களை நம்பியிருக்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 10.8500pt ;mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(f)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சட்டத்தால் அனுமதிக்கப்பட்ட அதிகபட்ச அளவிற்கு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் துணை நிறுவனங்கள் மற்றும் தொடர்புடைய தரப்பினர் ஒவ்வொருவரும் பின்வருவனவற்றால் அல்லது இவற்றால் ஏற்படும் எந்தவொரு இழப்பு அல்லது சேதத்திற்கும் உங்களுக்கு எதிரான அனைத்துப் பொறுப்பையும் மறுக்கிறோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >:</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.5500pt ;" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(i) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐப் பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பயன்படுத்த இயலாமை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது கிடைப்பது அல்லது கிடைக்காதது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதில் உங்களின் நிராகரிப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >செயலிழப்பு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மோசடி அல்லது அலட்சியம் ஆகியவை அடங்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.5500pt ;mso-list:l14 level1 lfo21;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(ii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளுக்கு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளிலிருந்து அல்லது சேவைகளின் வழியாக தகவல்களை இயக்குதல் அல்லது பரிமாற்றம் செய்வதில் ஏதேனும் குறைபாடு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குறுக்கீடு அல்லது தாமதங்கள் ஏற்படுதல் அல்லது தகவல்களைப் பகிர்வதில் தோல்வி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >திருட்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அழித்தல் அல்லது எங்கள் பதிவுகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிரல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவையகம் அல்லது சேவைகளுடன் தொடர்புடைய பிற உள்கட்டமைப்புகளை அங்கீகரிக்கப்படாத அணுகல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >; </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.7500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l14 level1 lfo21;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்த நேரத்திலும் செயல்பாட்டில் இல்லாதது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 12.5000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l14 level1 lfo21;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(iv)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஏதேனும் எதிர்பாராத நிகழ்வுகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.3000pt ;mso-list:l14 level1 lfo21;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(v)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >திட்டமிடப்பட்ட செயலிழப்பு நேரம் மற்றும் திட்டமிடப்படாத செயலிழப்பு நேரம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 12.7500pt ;mso-list:l14 level1 lfo21;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(vi)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளைப் பாதிக்கக்கூடிய பொருந்தக்கூடிய சட்டத்தில் ஏற்படும் மாற்றம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 13.7000pt ;mso-list:l14 level1 lfo21;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(vii)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வாடிக்கையாளரால் ஒப்புதல் ரத்து செய்யப்படுதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(g)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதில் உள்ளதற்கு மாறாக எதையும் பொருட்படுத்தாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் அல்லது சேவைகளின் கீழ்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நேரடியாகவோ மறைமுகமாகவோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அல்லது எந்த வகையிலும் தொடர்புடையதாகவோ ஏற்படும் எந்தவொரு மறைமுக</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தற்செயலான</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சிறப்பு அல்லது தொடர் சேதங்கள் அல்லது வருவாய் இழப்பு அல்லது இலாபங்களுக்கு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாங்கள் அல்லது எங்கள் எந்தவொரு துணை நிறுவனங்கள் அல்லது தொடர்புடைய தரப்பினர் உங்களுக்கோ எந்தவொரு மூன்றாம் தரப்பினருக்கோ எந்தவிதப் பொறுப்பையும் கொண்டிருக்க மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நேரடி சேதங்களுக்கு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நடவடிக்கையின் வடிவம் எதுவாக இருந்தாலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் பொறுப்பு </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒப்பந்தத்தில்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >டார்ட் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அலட்சியம் உட்பட</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >)} 10,000 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ரூபாயை விட அதிகமாக இருக்காது என்பதை நீங்கள் ஒப்புக்கொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இங்குள்ள எந்தவொரு வரையறுக்கப்பட்ட தீர்வின் அத்தியாவசிய நோக்கத்தின் தோல்வி இருந்தபோதிலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலே உள்ள பொறுப்பு வரம்புகள் பொருந்தும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 12.0500pt ;line-height:144%;mso-list:l2 level1 lfo19;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(h)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் இந்த தளத்தை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐ அணுகும் நோக்கத்திற்காகப் பயன்படுத்துகிறீர்கள் என்றால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் சலுகைகளை மதிப்பிடுவதற்கு மட்டுமே </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களிடம் உள்ளது என்பதை நீங்கள் புரிந்துகொள்கிறீர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு சந்தர்ப்பத்திலும் இது ஒரு வணிக சேவையாகக் கருதப்படாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் சலுகைகளுக்கான சந்தாவைப் பயன்படுத்த</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >/</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பெற விரும்பினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்களை </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >sup</span><u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;" >port@cookie</span></u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >j</span><u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;" >ar.co.in</span></u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >&nbsp;-</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இல் தொடர்பு கொள்ளலாம்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >11.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இழப்பீடு</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தளத்தை அணுகுதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகள் அல்லது </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >Sandbox -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஐப் பயன்படுத்துதல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளை மீறுதல் அல்லது சேவைகளை அணுக உங்கள் சுயவிவரத்தைப் பயன்படுத்தக்கூடிய உங்களால் அல்லது மூன்றாம் தரப்பினரால் இந்த விதிமுறைகள் மீறப்படுதல் போன்ற காரணங்களால் ஏற்படும் எந்தவொரு உரிமைகோரல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கோரிக்கை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வழக்குகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீதித்துறை நடவடிக்கைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இழப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொறுப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேதங்கள் மற்றும் செலவுகள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வரம்பில்லாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அனைத்து சேதங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொறுப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தீர்வுகள் மற்றும் வழக்கறிஞர் கட்டணங்கள் உட்பட</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆகியவற்றிலிருந்து எங்களை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் முதன்மை நிறுவனம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இணை நிறுவனங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >துணை நிறுவனங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குழு நிறுவனங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கூட்டு முயற்சிகள் மற்றும் அவற்றின் அதிகாரிகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஊழியர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இயக்குநர்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முகவர்கள் மற்றும் பிரதிநிதிகளை நீங்கள் இழப்பீடு செய்து</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பாதுகாக்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="margin-bottom:6.0000pt;tab-stops:left blank 13.2500pt ;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >12.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சட்ட எல்லை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிர்வகிக்கும் சட்டம் மற்றும் முரண்பாடுகளுக்கான தீர்வு</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.5500pt ;mso-list:l4 level1 lfo22;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த ஒப்பந்தமானது இந்தியச் சட்டங்களினால் நிர்வகிக்கப்படும் மற்றும் அவற்றின் அடிப்படையில் பொருள்கொள்ளப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்தப் பிரிவில் உள்ள பிற விதிகளுக்கு உட்பட்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் அல்லது சேவைகளின் பயன்பாட்டிலிருந்து எழும் அனைத்துப் பிரச்சினைகளுக்கும் புனேவில் உள்ள நீதிமன்றங்கள் பிரத்யேக அதிகார வரம்பைக் கொண்டிருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 12.0500pt ;line-height:144%;mso-list:l4 level1 lfo22;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளிலிருந்து எழும் எந்தவொரு சர்ச்சைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மோதல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முரண்பாடுகள் அல்லது வேறுபாடுகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தற்போதைக்கு நடைமுறையில் உள்ள </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >1996 </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆம் ஆண்டு நடுவர் மன்றம் மற்றும் சமரசச் சட்டத்தின்படி புனேவில் உள்ள நடுவர் மன்றத்தால் தீர்க்கப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இது இந்தப் பிரிவில் குறிப்பு மூலம் இணைக்கப்பட்டதாகக் கருதப்படுகிறது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நடுவர் மன்றத்தின் மொழி ஆங்கிலமாக இருக்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.3000pt ;mso-list:l4 level1 lfo22;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நடுவர் மன்றத்தில் உள்ள தரப்பினர் நடுவர் மன்றத் தகவல்களை ரகசியமாக வைத்திருக்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் சட்டத்தின்படி அவ்வாறு செய்ய வேண்டிய அவசியம் ஏற்பட்டால் தவிர</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தேவையின் அடிப்படையில் அல்லது சட்ட ஆலோசகர்களுக்குத் தவிர வேறு யாருக்கும் வெளியிடக்கூடாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நடுவரின் முடிவே இறுதியானது மற்றும் அனைத்து தரப்பினரையும் கட்டுப்படுத்தும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.8000pt ;mso-list:l4 level1 lfo22;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு முரண்பாடு தொடர்பாகவும் நடுவர் மன்றத்தில் உள்ள ஒவ்வொரு தரப்பினரும் அவரவர் சொந்த செலவுகளை அவர்களே ஏற்க வேண்டும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆன்லைன் முரண்பாடு தீர்வு அமைப்பு</span><u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(51,94,232);
font-weight:normal;text-decoration:underline;text-underline:single;
font-style:normal;font-variant:normal;font-size:12.75pt;" >OPR</span></u><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >&nbsp;</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இடம் நீங்கள் முரண்பாட்டைத் தெரிவிக்கலாம்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="margin-bottom:6.0000pt;tab-stops:left blank 13.0000pt ;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >13.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குறைதீர்ப்பு வழிமுறைகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.5500pt ;mso-list:l8 level1 lfo23;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் ஏதேனும் குறைகளைத் தெரிவிக்க விரும்பினால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வலைத்தளத்தில் உள்ள குறை தீர்க்கும் விருப்பத்தைப் பார்க்கவும்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.8000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l8 level1 lfo23;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எப்படியிருந்தாலும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >புகார் அளிக்கப்பட்ட தேதியிலிருந்து </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >30 (</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >முப்பது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நாட்களுக்குள் உங்கள் புகார் தீர்க்கப்படுவதை நாங்கள் உறுதி செய்வோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.3000pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l8 level1 lfo23;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அந்தக் காலகட்டத்திற்குள் புகார் தீர்க்கப்படாவிட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கீழே குறிப்பிடப்பட்டுள்ள முகவரிகளில் நீங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >RBI -</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >யிடம் மேல்முறையீடு செய்யலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >-</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><div align=center ><table class=MsoNormalTable  border=0  cellspacing=0  style="border-collapse:collapse;mso-table-layout-alt:fixed;border:none;
mso-padding-alt:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;" ><tr style="height:16.3000pt;" ><td width=466  valign=center  colspan=2  style="width:279.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  align=center  style="margin-bottom:0.0000pt;text-align:center;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >மும்பை </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >(</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >பிராந்திய அலுவலகம்</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >)</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td></tr><tr style="height:16.5500pt;" ><td width=56  valign=center  style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >அதிகார வரம்பு</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td><td width=410  valign=center  style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >மகாராஷ்டிரா மாநிலம் மற்றும் கோவா மாநிலம்</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td></tr><tr style="height:15.8500pt;" ><td width=56  valign=center  style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >முகவரி</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td><td width=410  valign=center  style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >3</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >வது தளம்</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >, RBI </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >கட்டிடம்</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >, </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >மும்பை மத்திய ரயில் நிலையம் எதிரில்</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >, </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >மராத்தா மந்திர் அருகில்</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >, </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >பைகுல்லா</span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >, </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >மும்பை </span><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >- 400 008</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td></tr><tr style="height:16.1000pt;" ><td width=56  valign=center  style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >தொலைபேசி</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td><td width=410  valign=center  style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >022-2308 4121/2302 8436</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td></tr><tr style="height:16.3000pt;" ><td width=56  valign=center  style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >தொலைநகல்</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td><td width=410  valign=center  style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:none;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >022-2302 2011</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td></tr><tr style="height:16.5500pt;" ><td width=56  valign=center  style="width:33.8500pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:none;border-top:1.0000pt solid windowtext;
mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;mso-border-bottom-alt:0.5000pt solid windowtext;" ><p class=22  style="margin-bottom:0.0000pt;" ><span class="18"  style="font-family:Arial;color:rgb(22,28,45);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >மின்னஞ்சல்</span><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td><td width=410  valign=center  style="width:246.0000pt;padding:0.0000pt 0.5000pt 0.0000pt 0.5000pt ;border-left:1.0000pt solid windowtext;
mso-border-left-alt:0.5000pt solid windowtext;border-right:1.0000pt solid windowtext;mso-border-right-alt:0.5000pt solid windowtext;
border-top:1.0000pt solid windowtext;mso-border-top-alt:0.5000pt solid windowtext;border-bottom:1.0000pt solid windowtext;
mso-border-bottom-alt:0.5000pt solid windowtext;" ><p class=22  style="margin-bottom:0.0000pt;" ><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><a href="mailto:dnbsmro@rbi.or" >dnbsmro@rbi.or</a></span><span class="18"  style="font-family:Arial;color:rgb(51,94,232);font-weight:normal;
font-style:normal;font-variant:normal;font-size:12.75pt;" >g</span><u><span class="18"  style="font-family:Arial;color:rgb(51,94,232);font-weight:normal;
text-decoration:underline;text-underline:single;font-style:normal;
font-variant:normal;font-size:12.75pt;" >.in</span></u><span style="font-family:Arial;color:rgb(56,76,116);font-size:12.75pt;" ><o:p></o:p></span></p></td></tr></table></div><p class=MsoNormal  style="margin-bottom:3.9500pt;line-height:0.0500pt;mso-line-height-rule:exactly;" ><span style="mso-spacerun:'yes';font-family:'Courier New';color:rgb(0,0,0);
font-size:12.0000pt;" ><o:p>&nbsp;</o:p></span></p><p class=MsoBodyText  align=justify  style="margin-bottom:9.0000pt;tab-stops:left blank 13.0000pt ;text-align:justify;
text-justify:inter-ideograph;mso-list:l19 level1 lfo1;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(22,28,45);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >14.<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(22,28,45);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இதர விதிகள்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.8000pt ;line-height:144%;mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(a)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >திருத்தங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளை எந்த நேரத்திலும் மாற்றுவதற்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >சேவைகளைப் பயன்படுத்துவதில் புதிய அல்லது கூடுதல் விதிமுறைகள் அல்லது நிபந்தனைகளைச் சேர்ப்பதற்கும் எங்களுக்கு உரிமை உண்டு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அத்தகைய திருத்தங்கள் மற்றும் கூடுதல் விதிமுறைகள் மற்றும் நிபந்தனைகள் உங்களுக்குத் தெரிவிக்கப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் வெளிப்படையாக நிராகரிக்கப்படாவிட்டால் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் முடிவடையும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >), </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உடனடியாக அமலுக்கு வந்து இந்த விதிமுறைகளுடன் சேர்க்கப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நீங்கள் அத்தகைய மாற்றங்களை ஏற்க மறுத்தால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகள் நிறுத்தப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(b)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தீவிரத்தன்மை</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் எந்தவொரு விதியும் ஏதேனும் நீதிமன்றம் அல்லது பிற தகுதிவாய்ந்த அதிகாரியால் சட்டவிரோதமானது அல்லது செயல்படுத்த முடியாதது என்று தீர்மானிக்கப்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் பிற விதிகள் தொடர்ந்து நடைமுறையில் இருக்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு சட்டவிரோதமான அல்லது செயல்படுத்த முடியாத விதியும் அதன் ஒரு பகுதி நீக்கப்பட்டால் சட்டப்பூர்வமானதாக அல்லது செயல்படுத்தக்கூடியதாக இருந்தால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அந்தப் பகுதி நீக்கப்பட்டதாகக் கருதப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மேலும் மீதமுள்ள விதி தொடர்ந்து நடைமுறையில் இருக்கும் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அது பிரிவின் தெளிவான நோக்கத்திற்கு முரணாக இல்லாவிட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தொடர்புடைய விதியின் முழுமையும் நீக்கப்பட்டதாகக் கருதப்படும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >).</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.5500pt ;text-align:justify;text-justify:inter-ideograph;
mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(c)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒதுக்கீடுகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் முன் எழுத்துப்பூர்வ ஒப்புதல் இல்லாமல் இந்த விதிமுறைகளின் கீழ் உங்களின் உரிமைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கடமைகள் அல்லது உடன்படிக்கைகளை நீங்கள் எந்த வகையிலும் உரிமம் வழங்கவோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விற்கவோ</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மாற்றவோ அல்லது மற்றொருவருக்கு ஒதுக்கவோ கூடாது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த ஒப்புதலை எங்கள் சொந்த விருப்பப்படியும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பொருத்தமானதாகக் கருதும் எந்தவொரு நிபந்தனைகளுக்கும் உட்பட்டும் நாங்கள் வழங்கலாம் அல்லது நிறுத்தி வைக்கலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உங்களுக்கு எந்த முன்னறிவிப்பும் இல்லாமல்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் எந்தவொரு துணை நிறுவனங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இணை நிறுவனங்கள் அல்லது முதன்மை நிறுவனங்களுக்கு அல்லது சேவைகளுடன் தொடர்புடைய எந்தவொரு வணிகத்தின் ஆர்வத்தில் எந்தவொரு வாரிசுக்கும் எங்கள் உரிமைகளை நாங்கள் ஒதுக்கலாம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(d)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >அறிவிப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் கீழ் எங்களுக்கான அனைத்து அறிவிப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கோரிக்கைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வேண்டுகோள்கள் மற்றும் தீர்மானங்கள் </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >(</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வழக்கமான செயல்பாட்டுத் தொடர்புகளைத் தவிர</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >) </span><span><a href="mailto:info@cookiejar.co.in" ><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >info@cookiejar.co.in</span></a></span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" >என்ற மின்னஞ்சல் முகவரிக்கு அனுப்பப்படும்</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.3000pt ;mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(e)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மூன்றாம் தரப்பினர் உரிமைகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு மூன்றாம் தரப்பினருக்கும் இங்கு உள்ள எந்தவொரு விதிமுறைகளையும் அமல்படுத்த எந்தவித உரிமையும் இருக்காது</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  align=justify  style="tab-stops:left blank 11.1000pt ;text-align:justify;text-justify:inter-ideograph;
line-height:145%;mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(f)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எதிர்பாராத நிகழ்வு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் கடமைகளைச் செய்வதிலிருந்து அல்லது எங்கள் வணிகத்தை மேற்கொள்வதிலிருந்து தடுக்கப்பட்டால் அல்லது தாமதப்படுத்தப்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எங்கள் நியாயமான கட்டுப்பாட்டிற்கு அப்பாற்பட்ட செயல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிகழ்வுகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குறைபாடுகள் அல்லது விபத்துக்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >வேலைநிறுத்தங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >பயன்பாட்டு சேவை அல்லது தொலைத்தொடர்பு வலையமைப்பின் தோல்வி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இயற்கை சீற்றங்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >போர்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >கலவரம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >உள்நாட்டுக் கலவரம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >தீங்கிழைக்கும் சேதம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எந்தவொரு சட்டம் அல்லது அரசாங்க ஒழுங்கு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >விதி</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஒழுங்குமுறை அல்லது வழிகாட்டுதல் உள்ளிட்ட செயல்கள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >நிகழ்வுகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >குறைபாடுகள் அல்லது விபத்துக்கள் மூலம் நாங்கள் உங்களுக்கு எந்தப் பொறுப்பையும் ஏற்க மாட்டோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. ("</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >எதிர்பாராத நிகழ்வு</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >")</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p><p class=MsoBodyText  style="tab-stops:left blank 11.8000pt ;mso-list:l3 level1 lfo24;" ><![if !supportLists]><span style="font-family:Arial;color:rgb(56,76,116);letter-spacing:0.0000pt;
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" ><span style='mso-list:Ignore;' >(g)<span>&nbsp;</span></span></span><![endif]><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >மொழிபெயர்ப்புகள்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >: </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளை நீங்கள் இன்னும் விரிவாகப் புரிந்துகொள்ள உதவுவதற்காக மட்டுமே</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் மொழிபெயர்க்கப்பட்ட பதிப்புகளை நாங்கள் உங்களுக்கு வழங்குகிறோம்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >. </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >இந்த விதிமுறைகளின் ஆங்கிலப் பதிப்பிற்கும் மொழிபெயர்க்கப்பட்ட பதிப்பிற்கும் இடையில் ஏதேனும் முரண்பாடு ஏற்பட்டால்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >, </span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >ஆங்கிலப் பதிப்பின் விதிமுறைகளே மேலோங்கும்</span><span class="17"  style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-weight:normal;font-style:normal;font-variant:normal;
font-size:12.75pt;" >.</span><span style="mso-spacerun:'yes';font-family:Arial;color:rgb(56,76,116);
font-size:12.75pt;" ><o:p></o:p></span></p></div><!--EndFragment--></body></html>
    `,
};
